module.exports = __webpack_public_path__ + "img/48_15.3e0556a4.png";